import classnames from 'classnames'
import PersistAffordabilityButton from '../../PersistAffordabilityButton'
import Question from '../../../../../shared/Questions/QuestionSingleContainer'
import PrequalTabFooter from '../PrequalTabFooter'
import { CUSTOMER_MESSAGES } from '../../../../../../constants/customerMessages'
import Prequal from './Prequal'

import styles from './HasPrequalScreen.module.scss'

const HasPrequalScreen = ({ firstPrequal, intl }) => (
  <>
    <Prequal data={firstPrequal} />
    <PersistAffordabilityButton className={styles.button} />
    <PrequalTabFooter>
      <Question
        className={styles.question}
        questionTopic={CUSTOMER_MESSAGES.BUYER_WITH_PREQUAL.topic}
        questionTopicKey={CUSTOMER_MESSAGES.BUYER_WITH_PREQUAL.topicKey}
        question={intl.formatMessage(CUSTOMER_MESSAGES.BUYER_WITH_PREQUAL.message)}
      />
      <Question
        className={classnames(styles.question, styles.lastQuestion)}
        questionTopic={CUSTOMER_MESSAGES.BUYER_WITH_PREQUAL.topic}
        questionTopicKey={CUSTOMER_MESSAGES.BUYER_WITH_PREQUAL.topicKey}
        placeholder={intl.formatMessage(CUSTOMER_MESSAGES.BUYER_WITH_PREQUAL.secondaryMessage)}
      />
    </PrequalTabFooter>
  </>
)

export default HasPrequalScreen
